module.exports = __webpack_public_path__ + "img/0.50ad8377.gif";